<template>
  <div id="app">
    <transition :name="transitionName">
      <navigation>
        <router-view  />
      </navigation>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      transitionName: ''
    }
  },
}
</script>

<style lang="less">
html,
body {
  height: 100%;
  padding: 0;
  margin: 0;
}
#app {
  font-family: Montserrat-Regular, Montserrat;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
  .van-image{
    img{
      object-fit: cover;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue